import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';

import { AuthService } from '../services/auth.service';

@Directive({
    selector: '[slIfAllowed]',
    standalone: false
})
export class IfAllowedDirective implements OnInit {
    @Input('slIfAllowed') permission: string;

    private readonly templateRef = inject(TemplateRef);
    private readonly viewContainer = inject(ViewContainerRef);
    private readonly authService = inject(AuthService);

    ngOnInit(): void {
        if (!!this.permission && this.authService.hasPermission(this.permission)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }
}
